module.exports = __webpack_public_path__ + "img/stt-edit-hover.1fa206ed.png";